export default [
  {
    path: 'gestao/loterias/resultados',
    name: 'resultados',
    component: () => import('./index'),
    meta: {
      visible: true,
      title: 'Resultados',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Gestão', link: 'gestao' },
        { name: 'Loterias', link: 'loterias' },
        { name: 'Resultados' }
      ]
    }
  }
]